/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useCommonFormWidgetStyles = makeStyles((theme: Theme) => ({
  warn: {
    color: theme.palette.warning.main,
    position: 'absolute',
    top: '50%',
    left: '-30px',
    height: '20px',
    transform: 'translate(0, -50%)',
  },
  warnIcon: {
    width: 'auto',
    height: '100%',
  },
  widgetMenuButton: {
    opacity: 0,
    pointerEvents: 'none',
    visibility: 'hidden',
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)',
    padding: '10px',
  },
  flexFormWrapper: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
  },
}));

export const useTextFormWidgetStyles = makeStyles(() => ({
  fieldControl: {
    maxWidth: '100%',
    position: 'relative',
  },
  field: {
    padding: '0 25px 0 0',

    '&:hover $widgetMenuButton': {
      opacity: 1,
      pointerEvents: 'all',
      visibility: 'visible',
    },

    '& input:focus + $widgetMenuButton': {
      opacity: 1,
      pointerEvents: 'all',
      visibility: 'visible',
    },
  },
  widgetMenuButton: {},
}));

export const useSelectFormWidgetStyles = makeStyles(() => ({
  formIcon: {
    fontSize: '24px',
    color: '#A2A7AE',
  },
  widgetMenuButton: {
    right: '20px !important',
    zIndex: 2,
  },
  selectControl: {
    width: '100%',
  },
  select: {
    paddingRight: 0,
    '&:hover $widgetMenuButton': {
      opacity: 1,
      pointerEvents: 'all',
      visibility: 'visible',
    },

    '&.Mui-focused $widgetMenuButton': {
      opacity: 1,
      pointerEvents: 'all',
      visibility: 'visible',
    },
  },
}));

export const useCheckboxFormWidgetStyles = makeStyles(() => ({
  root: {
    '&:hover $widgetMenuButton': {
      opacity: 1,
      pointerEvents: 'auto',
      visibility: 'visible',
    },
    position: 'relative',
    width: 'max-content',
  },
  label: {
    color: '#2C333B',
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '-0.4px',
    lineHeight: '20px',
  },
  labelRoot: {
    '&:hover > $colorSecondary': {
      color: '#F16623',
    },
    marginLeft: '0px',
    width: 'max-content',
  },
  checkboxRoot: {
    padding: '0',
    marginRight: '8px',
  },
  colorSecondary: {},
  widgetMenuButton: {
    right: '-25px !important',
  },
}));
